import React from "react";

import svg from "../../assets/images/icons/RichText/bold.svg";

export const BoldIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Bold"}
    />
);
